import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import moment from 'moment'

import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Menu } from 'primereact/menu';
import { Paginator } from 'primereact/paginator';


import Header from '@components/Header';
import Log from '@components/Bitacora/Log'

import { getSearchBitacora } from '@actions/bitacora'

import './styles.scss'

const ROWS_DEFAULT = 10

let reloadLoadData;

class SearchSupplier extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loading: false,
      bitacora: [],
      categoriesCatalog: [],
      categorySelected: '',
      actionSelected: '',
      actionsCatalog: [],
      findText: '',
      from: '',
      // from: new Date(),
      to: new Date(),
      sort: 'timestamp:desc',
      errors: [],
      searchValues: {
        category: '',
        transactionName: '',
        find: '',
        sort: 'timestamp:desc',
        from: '',
        to: '',
        isReaload: false
      },
      categoryIsRequired: false,
      first: 0,
      totalRecords: 0,
      isShowTimestamp: false,
      indexReloadSelected: 1,
      isReload: false
    };
    this.items = [
      {
        label: 'Fecha',
        items: [
          {
            label: 'Asc',
            icon: 'pi pi-arrow-up',
            command:(e) => {
              this.setState({sort: 'timestamp:asc'}, () => this.searchData())
            }
          },
          {
            label: 'Desc',
            icon: 'pi pi-arrow-down',
            command:(e) => {
              this.setState({sort: 'timestamp:desc'}, () => this.searchData())
            }
          }
        ]
      },
      // {
      //   label: 'Acción',
      //   items: [
      //     {
      //       label: 'Asc',
      //       icon: 'pi pi-arrow-up',
      //       command:(e) => {
      //         this.setState({sort: 'transactionName:asc'})
      //       }
      //     },
      //     {
      //       label: 'Desc',
      //       icon: 'pi pi-arrow-down',
      //       command:(e) => {
      //         this.setState({sort: 'transactionName:desc'})
      //       }
      //     }
      //   ]
      // }
    ]

    this.itemsReload = [
      {
        id: 1,
        label: 'No actualizar',
        command:(e) => {
          this.setState({indexReloadSelected: 1, isReload: false});
          clearTimeout(reloadLoadData);
        }
      },
      {
        id: 2,
        label: '30 seconds',
        ms: 30000,
        command:(e) => {
          this.setState({indexReloadSelected: 2, isReload: true})
        }
      },
      {
        id: 3,
        label: '45 seconds',
        ms: 45000,
        command:(e) => {
          this.setState({indexReloadSelected: 3, isReload: true})
        }
      },
      {
        id: 4,
        label: '1 min',
        ms: 60000,
        command:(e) => {
          this.setState({indexReloadSelected: 4, isReload: true})
        }
      }
    ]
  }

  componentDidMount() {
    this.setCategoriesCatalog()
    const fromDate = moment().subtract(1, 'months')
    this.setState({from: new Date(fromDate)})
    // this.loadData()
    this.setState({loadingPage: false})
  }

  componentDidUpdate(prevProps, prevState) {

    if (!prevState.searchValues.isReload && this.state.searchValues.isReload) {
      const isInitial = true
      this.repeatLoad(isInitial)
    } else if (prevState.searchValues.isReload && !this.state.searchValues.isReload) {
      clearTimeout(reloadLoadData)
    }

  }

  componentWillUnmount () {
      clearTimeout(reloadLoadData)
  }

  repeatLoad = async (initial = false) => {
    const { indexReloadSelected } = this.state
    const getTimer = this.itemsReload.find(item => item.id === indexReloadSelected)
    if(!initial) await this.loadData()
    reloadLoadData = setTimeout(async () => { this.repeatLoad()}, getTimer.ms)
  }

  setCategoriesCatalog = () => {
    const { t, transactionNameCatalog } = this.props
    const newCategoriesCatalog = transactionNameCatalog.map(item => ({ label: t(item.categoria), id: item.cateogoriaId }))
    this.setState({categoriesCatalog: newCategoriesCatalog})
  }

  setActionsCatalog = () => {
    const { t, transactionNameCatalog } = this.props
    const { categorySelected } = this.state
    const getActionsByCagory = transactionNameCatalog.find(item => item.cateogoriaId === categorySelected.id )
    const newActionsCatalog = getActionsByCagory.acciones.map(item => ({ label: t(item.nombre), id: item.id, transactionName: item.transaccion }))
    this.setState({actionsCatalog: newActionsCatalog})
  }

  searchData = () => {
    const { categorySelected, actionSelected, sort, to, from, findText, isReload, searchValues } = this.state
    if (searchValues.isReload) return this.setState({indexReloadSelected: 1, isReload: false, searchValues: {...searchValues, isReload: false}})
    if (!categorySelected) return this.setState({categoryIsRequired: true})
    this.setState({
      searchValues: {
        category: categorySelected?.label || '',
        transactionName: actionSelected?.transactionName || '',
        find: findText || '',
        sort: sort || '',
        from: from || '',
        to: to || '',
        isReload
      },
      first: 0
    }, async () => {
      await this.loadData()
    })
  }

  loadData = async () => {
    const { getSearchBitacora } = this.props
    const { searchValues, first } = this.state
    // if (!searchValues.country) return this.setState({countryRequired: true})
    this.setState({ loading: true });
    const querys = {
      from: moment(searchValues.from).format('YYYY-MM-DD HH:mm:ss'),
      to: moment(searchValues.to).format('YYYY-MM-DD HH:mm:ss'),
      limit: ROWS_DEFAULT,
      offset: first
    }
    if (searchValues.category) querys.category = searchValues.category
    if (searchValues.transactionName) querys.transactionName = searchValues.transactionName
    if (searchValues.find) querys.find = searchValues.find
    if (searchValues.sort) querys.sort = searchValues.sort

    const response = await getSearchBitacora(querys);
    if (!response?.status) {
      return this.setState({
        loading: false,
        bitacora: response.data.messages,
        totalRecords: response.data.total_results,
      });
    }
    return this.setState({
      loading: false,
      bitacora: [],
      totalRecords: 0
    })
  }

  onChange = ({target}) => {
    if (target.name === 'findText') {
      target.value = target.value.replace('AND', '')
      target.value = target.value.replace('and', '')
      target.value = target.value.replace('OR', '')
      target.value = target.value.replace('or', '')
      target.value = target.value.replace('*', '')
      target.value = target.value.replace('(', '')
      target.value = target.value.replace(')', '')
      target.value = target.value.replace('[', '')
      target.value = target.value.replace(']', '')
    }
    this.setState({[target.name]: target.value}, () => {
      if (target.name === 'categorySelected') {
        this.setState({categoryIsRequired: false, actionSelected: ''})
        this.setActionsCatalog()
      }
    });
  };

  onPageChange = (event) => {
    this.setState({
      first: event.first
    }, () => this.loadData());
}

  columnResponsive = (rowData, detail) => (
    <>
      <span className="p-column-title">{detail.header}</span>
      {rowData[detail.field]}
    </>
  )

  render() {
    const { t, history } = this.props;
    const { 
      errors,
      searchSupplier,
      categoriesCatalog,
      categorySelected,
      loadingPage,
      actionsCatalog,
      actionSelected,
      findText,
      from,
      to,
      categoryIsRequired,
      first,
      totalRecords,
      bitacora,
      isShowTimestamp,
      loading,
      searchValues
    } = this.state;

    const isFormFieldValid = (name) => !!errors[name];
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
      </>
    );


    const renderLogs = bitacora.map(item => (
      <div className='p-col-12' key={item.message._id}>
        <Log
          timestamp={item.message.timestamp}
          message={item.message.message}
          userEmail={item.message.user_email}
          userRole={item.message.user_role}
          id={item.message._id}
          action={item.message.transactionName}
          category={item.message.category}
        />
      </div>
    ))
  
    if (loadingPage) return true
    return (
      <div className="p-fluid p-grid bitacora">
        <div className="p-col-12">
          <Header title={t('Bitacora de cambios')} rightComponent={rightHeader} />
          <div className="card p-grid">
            <div className='p-col-12  p-md-12 p-lg-10 p-grid'>
              <div className="p-d-flex p-ai-center p-pr-4">
                <Button
                  icon="pi pi-clock"
                  className="p-button p-button-secondary p-button-raised btn-lightgray"
                  onClick={() => this.setState({isShowTimestamp: !isShowTimestamp})}
                />
              </div>
              { isShowTimestamp ? (
                <>
                  <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center">
                    <label className="p-mr-2 p-text-bold">{t('Desde')}:</label>
                    <Calendar
                      name="from"
                      value={from}
                      onChange={this.onChange}
                      showTime
                      showSeconds
                      showIcon
                      maxDate={new Date()}
                      style={{ width: '100%' }}
                    />
                    {getFormErrorMessage(`from`)}
                  </div>
                  <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center">
                    <label className="p-mr-2 p-text-bold">{t('Hasta')}:</label>
                    <Calendar
                      name="to"
                      value={to}
                      onChange={this.onChange}
                      showTime
                      showSeconds
                      showIcon
                      // minDate={from}
                      maxDate={new Date()}
                      style={{ width: '100%' }}
                    />
                    {getFormErrorMessage(`to`)}
                  </div>
                </>
              ) : <div className='p-col-8'/>}
              <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center">
                <label className="p-mr-2 p-text-bold">{t('Categoría')}:</label>
                <Dropdown
                  name="categorySelected"
                  value={categorySelected}
                  options={categoriesCatalog}
                  onChange={this.onChange}
                  optionLabel="label"
                  // filter
                  // showClear
                  filterBy="label"
                  placeholder=""
                  style={{ width: '100%' }}
                  className={classNames({
                    'p-invalid': categoryIsRequired,
                  })}
                />
                {/* {getFormErrorMessage(`categorySelected`)} */}
              </div>
              <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center">
                <label className="p-mr-2 p-text-bold">{t('Acción')}:</label>
                <Dropdown
                  name="actionSelected"
                  value={actionSelected}
                  options={actionsCatalog}
                  onChange={this.onChange}
                  optionLabel="label"
                  // filter
                  // showClear
                  filterBy="label"
                  placeholder=""
                  style={{ width: '100%' }}
                  disabled={!categorySelected}
                  // className={classNames({
                  //   'p-invalid': countryRequired,
                  // })}
                />
              </div>
              <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center">
                <span className="p-inputgroup">

                  <Button icon="pi pi-user"/>
                  <InputText
                    name="findText"
                    type="text"
                    value={findText}
                    placeholder={t('Ej. correo, acción, mensaje, etc..')}
                    onChange={this.onChange}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`findText`),
                    })}
                  />
                </span>
                {getFormErrorMessage(`findText`)}
              </div>
              
            </div>
            <div className='p-col-12 p-md-12 p-lg-2 p-grid p-d-flex p-jc-end p-ai-end'>
              <div className="p-col-12 p-lg-12 p-pr-0" style={{"textAlign": "end"}}>
                <Button
                  // label={t('Buscar')}
                  icon={searchValues.isReload ? "pi pi-pause" : "pi pi-play"}
                  className="p-button p-button-raised p-button-plain p-button-success btn-lightgray"
                  onClick={() => this.searchData()}
                  style={{"width": "70%"}}
                />
                <Menu model={this.itemsReload} popup ref={el => this.menuReload = el} id="popup_menu" />
                <Button
                  icon="pi pi-caret-down"
                  onClick={(event) => this.menuReload.toggle(event)}
                  className="p-button p-button-secondary p-button-raised  btn-lightgray"
                  aria-controls="popup_menu"
                  aria-haspopup
                />
              </div>
            </div>
          </div>

          <div className="card p-grid">
            { totalRecords ? (
              <>
                <div className='p-col-12  p-d-flex p-jc-between p-ai-center p-pr-3 p-pt-0'>
                  <div className='p-d-flex'>
                    { loading && (
                      <div className="p-d-flex p-ai-center p-pr-4 rec-animation">
                        ◉
                      </div>
                    )}
                  </div>
                  <div className="p-col-1">
                    <Menu model={this.items} popup ref={el => this.menu = el} id="popup_menu" />
                    <Button
                      icon="pi pi-filter"
                      label={searchValues.sort === 'timestamp:desc' ? '↓' : '↑'}
                      onClick={(event) => this.menu.toggle(event)}
                      className="p-button p-button-secondary p-button-raised btn-lightgray"
                      aria-controls="popup_menu"
                      style={{"width": "53px"}}
                      aria-haspopup
                    />
                  </div>
                </div>
                <div className='p-col-12 p-grid p-pl-4'>
                  <div className='p-col-4'>
                    <h5 className='p-text-bold'>{t('Timestamp')}</h5>
                  </div>
                  <div className='p-col-4'>
                    <h5 className='p-text-bold'>{t('Acción')}</h5>
                  </div>
                  <div className='p-col-4'>
                    <h5 className='p-text-bold '>{t('Nombre')}</h5>
                  </div>
                </div>
                {renderLogs}
                <div className='p-col-12'>
                  <Paginator
                    first={first }
                    rows={ROWS_DEFAULT}
                    totalRecords={totalRecords}
                    onPageChange={this.onPageChange}
                    // first={first}
                  />
                </div>
              </>
            ) : (
              <div className="p-col-12 not-information">
                {t('No se encontraron resultados')}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  transactionNameCatalog: state.catalogs.transactionNameCatalog,
});

const mapDispatchToProps = {
  getSearchBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(SearchSupplier);
